import { ShareDeletedSubscription, useShareDeletedSubscription } from 'gqlTypes'
import { ErrorHandler } from 'modules/tracing'

import { handleShareDeleted } from '../handlers'
import { SubscriptionEventHandler } from './types'

export interface ShareDeletedPayload {
  share: NonNullable<
    NonNullable<ShareDeletedSubscription['shareDeleted']>['share']
  >
}

export interface UseShareDeletedProps {
  /**
   * handler which is called _before_ share is removed/added from/to the cache
   * it is possible to use this handler to update the UI state if it is
   * necessary
   */
  onShareDeleted?: SubscriptionEventHandler<ShareDeletedPayload>
}

export const useShareDeleted = (props: UseShareDeletedProps = {}) => {
  const { onShareDeleted } = props

  return useShareDeletedSubscription({
    onSubscriptionData: ({ subscriptionData, client }) => {
      const share = subscriptionData.data?.shareDeleted.share
      if (!share) {
        ErrorHandler.shouldNeverHappen(
          `missing useShareDeletedSubscription payload, ${JSON.stringify(
            subscriptionData
          )}`
        )
        return
      }

      try {
        onShareDeleted?.({ share, client })
      } catch (e) {
        ErrorHandler.shouldNeverHappen(
          `onShareDeleted should not throw errors, ${JSON.stringify(e)}`
        )
      } finally {
        handleShareDeleted({
          cache: client,
          identifier: share.identifier,
        })
      }
    },
  })
}
